import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../../services/blog.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.scss']
})
export class ListaComponent implements OnInit {

  posts: any;
  articulo: any;
  imagen: string;
  titulo: string;
  contenido: string;
  comentarios: any;
  postId: string;
  post: any;

  constructor(private blogSvc: BlogService,
              private sanitizer: DomSanitizer,
              private router: Router) { }



  ngOnInit(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);

    this.blogSvc.cargarPost()
                .subscribe(res => {
                  this.posts = res;
                });
  }

  detallePost(pos: any){
    this.post = pos;
  }

  getVideoIframe(url) {
    var video, results;

    if (url === null) {
        return '';
    }
    results = url.match('[\\?&]v=([^&#]*)');
    video   = (results === null) ? url : results[1];

    return this.sanitizer.bypassSecurityTrustResourceUrl(video);
}


  borrarPost(idPost: string){
    Swal.fire({
      title: 'Está seguro?',
      text: `Se eliminará definitivamente este producto!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, borrarlo!',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.value) {
        this.blogSvc.deletePostById(idPost).then(() => {
          Swal.fire('Eliminado!', 'El artículo ha sido borrado.', 'success');
        }).catch((error) => {
          Swal.fire('Error!', 'Error al eliminar el artículo', 'error');
        });
      }
    });
  }

  deleteComment(idComm: string){
    this.blogSvc.deleteCommentById(this.postId, idComm);
  }

  editarpost(post: any){
    this.blogSvc.postSelect = post;
    this.router.navigate(['editarPost']);
    
  }

}
